import React, { useEffect, useRef, useState } from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import "../../assets/css/Home.css";
import {
  Divider,
  Grid,
  Typography,
  Link,
  Modal,
  Box,
  Input,
  IconButton,
} from "@mui/material";
import { gql, useMutation, useQuery } from "@apollo/client";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useNavigate, useParams } from "react-router-dom";
import { CopyAll, Delete, Lock, Search } from "@mui/icons-material";
import { CLONE_EVENT, REMOVE_EVENTS } from "../../graphql/mutations";

const Cancel = styled((props) => (
  <Button disableRipple variant="outlined" {...props} />
))({
  border: "none",
  height: "30px",
  fontSize: "0.8rem",
  color: "rgb(0,105,255)",
  "&:hover": {
    backgroundColor: "transparent",
    border: "none",
  },
});
const Next = styled((props) => <Button variant="outlined" {...props} />)({
  color: "rgb(0,105,255)",
  borderRadius: "30px",
  height: "30px",
});
const Events = (props) => {
  const [removeEvents] = useMutation(REMOVE_EVENTS);
  const [cloneEvents] = useMutation(CLONE_EVENT);
  const timeoutRef = useRef(null);
  const [currentVal, setCurrentVal] = useState();
  const [copiedText, setCopiedText] = useState("");
  const [reload, setReload] = useState(0);
  const [search, setSearch] = useState("");
  const [data, setData] = useState(props.data);
  const removeEvent = (propss) => {
    removeEvents({ variables: propss })
      .then((res) => {
        console.log(res);
        setReload(reload + 1);
        props.refetch();
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleCancel = (val) => {
    // perform the cancel action here
    removeEvent({ eventId: parseInt(val.id) });
  };
  const handleNevermind = () => {
    // do nothing
  };
  const CancelModal = (props) => {
    return (
      <Modal open={showCancelModal} onClose={() => setShowCancelModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "10px",
            outline: "none",
            maxWidth: "400px",
          }}
        >
          <Typography variant="h5" sx={{ mb: 2 }}>
            Are you sure you want to delete this event and all bookings with it?
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="contained"
              onClick={() => setShowCancelModal(false)}
              sx={{ mr: 2 }}
              style={{ background: "#d9bca9" }}
            >
              Nevermind
            </Button>
            <Button variant="outlined" onClick={() => handleCancel(props.val)}>
              Yes
            </Button>
          </Box>
        </Box>
      </Modal>
    );
  };
  const cloneEvent = (event, id) => {
    event.stopPropagation();
    cloneEvents({ variables: id })
      .then((res) => {
        props.refetch().then(() => {
          navigate("/app/update/" + res.data.cloneEvent);
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const [interfering, setInterfering] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  useEffect(() => {
    // Clear the previous timeout, if any
    clearTimeout(timeoutRef.current);

    // Set a new timeout
    timeoutRef.current = setTimeout(() => {
      setCopiedText(-1);
    }, 2000);

    // Clean up the timeout when the component unmounts
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, [copiedText]);
  const navigate = useNavigate();
  // const eventss = data.getEvents;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        flexDirection: "column",
      }}
    >
      <div style={{ width: "90%", padding: "20px 0", maxWidth: "1000px" }}>
        <Input
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setData(
              props.data.filter((item) => {
                return (
                  item.name
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase()) ||
                  item.desc
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase()) ||
                  item.location
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase()) ||
                  item.locationType
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
                );
              })
            );
          }}
          fullWidth
          placeholder="Search..."
          startAdornment={<Search fontSize="25px" />}
        />
      </div>
      <Grid
        container
        style={{
          width: "90%",
          maxWidth: "1000px",
          padding: "20px 0",
        }}
        gap={5}
      >
        {data.map((val, index) => (
          <Grid key={index} className="eventBox" item xs={12} md={5.7} lg={3}>
            <div className="colorTop" style={{ background: val.color }}></div>
            <div
              className="eventBoxContainer"
              onClick={() => navigate("/app/update/" + val.id)}
            >
              <div
                style={{
                  minHeight: "147px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "15px",
                }}
              >
                <div
                  className="displayFlex"
                  style={{ justifyContent: "space-between" }}
                >
                  <Typography
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                    variant="h5"
                    component="h2"
                  >
                    {val.hidden && <Lock />} {val.name}
                  </Typography>{" "}
                  <IconButton
                    onClick={(e) => {
                      cloneEvent(e, { eventId: parseInt(val.id) });
                    }}
                  >
                    <CopyAll />
                  </IconButton>
                </div>
                <Typography
                  variant="h6"
                  style={{ fontSize: "0.8rem" }}
                  component="h2"
                >
                  {val.locationType}
                </Typography>
                <div>
                  <Typography
                    variant="h6"
                    style={{
                      fontSize: "0.8rem",
                    }}
                    component="h2"
                    className="desc"
                  >
                    {val.desc}
                  </Typography>
                </div>
              </div>
              <Link
                onClick={(event) => {
                  event.stopPropagation();
                  window.location.href = `/${props.user}/events/${val.link}`;
                }}
                underline="hover"
              >
                Booking Page
              </Link>
            </div>
            <Divider />
            <div style={{ display: "flex" }}>
              <div
                style={{
                  padding: "14px 7px",
                  display: "flex",
                  flex: 1.5,
                }}
              >
                <Cancel
                  onClick={(event) => {
                    event.stopPropagation();
                    setCopiedText(val.link);
                    navigator.clipboard.writeText(
                      window.location.origin +
                        "/" +
                        props.user +
                        "/events/" +
                        val.link
                    );
                  }}
                  variant="outlined"
                  style={{
                    color: copiedText === val.link ? "green" : "rgb(0,105,255)",
                    display: "flex",
                    gap: "3px",
                  }}
                >
                  {copiedText !== val.link ? (
                    <ContentCopyIcon fontSize="24px" />
                  ) : (
                    ""
                  )}
                  {copiedText === val.link ? "Copied ✓" : "Copy Link"}
                </Cancel>
              </div>
              <div
                style={{
                  padding: "14px",
                  display: "flex",
                  justifyContent: "flex-end",
                  flex: 1,
                }}
              >
                <Next
                  style={{ border: "1px solid red", minWidth: "10px" }}
                  onClick={() => {
                    setCurrentVal(val);
                    setShowCancelModal(true);
                  }}
                >
                  <Delete color="error" />
                </Next>
              </div>
            </div>
          </Grid>
        ))}
        <CancelModal
          isOpen={showCancelModal}
          onCancel={handleCancel}
          val={currentVal}
          onNevermind={handleNevermind}
        />
      </Grid>
    </div>
  );
};

export default Events;
